<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>
          Admin Management
        </h1>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-results-details">
        <div class="row">
          <div class="col-xs-12 col-sm-4 m-b-sm">
            <router-link v-if="$userIsAdmin && !$userIsRestrictedAdmin" :to="{ name: 'admin.create' }" class="btn btn-sm btn btn-primary"><i class="fa fa-plus"></i> Add Admin</router-link>
          </div>
        </div>
      </div>

      <div class="dashboard-block">
        <pickstar-loading v-if="fetchingAdmins" class="m-t-lg"/>

        <no-results v-else-if="haveNoAdmins">
          There are no admins.
        </no-results>

        <ul v-else class="item-detail item-detail-profile">
          <system-admin-management-list-item
            v-for="admin in admins"
            :key="admin.id"
            :admin="admin"/>
        </ul>

        <lazy-loading
          class="text-center"
          :loading="loading"
          :reached-bottom="handleGetNextAdminsCallback"
          ref="lazyLoading">
          <pickstar-loading slot="loading"/>
          <span slot="finished"></span>
        </lazy-loading>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { assign } from 'lodash'
import { handleServerErrors, fetchResourceScope } from 'mixins'
import LazyLoading from 'codium-lazy-loading'
import SystemAdminManagementListItem from './SystemAdminManagementListItem'

export default {
  mixins: [handleServerErrors, fetchResourceScope],

  props: {
    status: {
      required: false,
      default: 'all'
    }
  },

  computed: {
    ...mapState('admin', ['admins', 'pagination']),
    ...mapState('app', ['loading']),

    queryParams () {
      let params = {
        status: this.$userIsAdmin
          ? this.status
          : 'all'
      }

      return params
    },

    haveNoAdmins () {
      return this.admins.length === 0
    }
  },

  components: {
    SystemAdminManagementListItem,
    LazyLoading
  },

  data () {
    return {
      searchName: null,
      fetchingAdmins: false
    }
  },

  beforeDestroy () {
    this.resetAdmins()
  },

  watch: {
    '$route' () {
      this.resetAdmins()

      this.fetchingAdmins = true

      this.getAdmins(this.queryParams)
        .then(() => {
          this.$nextTick(() => {
            if (!this.$refs.lazyLoading) {
              return
            }

            this.$refs.lazyLoading.$emit('reset')
          })
        })
        .catch(this.handleServerErrorsCallback)
        .finally(() => {
          this.fetchingAdmins = false
        })
    }
  },

  created () {
    // Prevent managers from changing the status to affect the list. We do further prevention
    // by hard-coding the status that is searched as "all" both frontend and backend.
    if (this.$userIsManager && this.status !== 'all') {
      this.$router.push({ name: 'talent.index' })

      return
    }

    this.searchName = this.$route.query.name || null

    this.getAdmins(this.queryParams)
      .catch(this.handleServerErrorsCallback)

    if (this.$userIsAdmin) {
      this.getAdminCounts(this.queryParams)
        .catch(this.handleServerErrorsCallback)
    }
  },

  methods: {
    ...mapActions('admin', ['getAdmins', 'getNextAdmins', 'getAdminCounts', 'resetAdmins']),

    handleNameSearchCallback () {
      let query = assign({}, this.$route.query)

      if (this.searchName) {
        query.name = this.searchName
      } else {
        delete query.name
      }

      this.$router.push({ query })

      return Promise.resolve()
    },

    handleGetNextAdminsCallback () {
      return this.getNextAdmins(this.queryParams)
    },

    classForStatus (status) {
      if (this.status === status) {
        return 'active'
      }

      return ''
    }
  }
}
</script>
